import {
  Button,
  Grid,
  MenuItem,
  OutlinedInput,
  Select,
  Typography,
} from "@mui/material";
import { Fragment } from "react";
import useInputObject from "../../../hooks/useInputObject";
import { printReport } from "../../../http/api/ReportSaveAPI";
import useDialog from "../../../hooks/useDialog";
import PrintParameterDialog from "./PrintSettingDialog/PrintParameterDialog";
import { getHyphenedDate } from "../../../utils/utils";
import PrintPreview from "./PrintPreview";
import PRINT_PARAMETER_FORMS from "./PrintSettingDialog/const/PrintParameterForms";

const PrintBar = (props) => {
  const { reportTypes, printPreview, setLoading } = props;
  const printSetting = useInputObject({
    targetDate: getHyphenedDate(new Date()),
    reportTypeId: 1,
  });
  
  /** 印刷パラメータダイアログ状態  */
  const printParameterDialogStatus = useDialog();

  /** 「印刷」押下時 */
  async function handlePrint() {

    let printParameter = {};
  
    /** 印刷パラメータダイアログを開く */
    if (printSetting.Value.reportTypeId in PRINT_PARAMETER_FORMS) {
      printParameter = await printParameterDialogStatus.open();

      if (!printParameter) {
        return;
      }
    }
 
    setLoading(true);
    try {
      let response = await printReport({
        ...printSetting.Value,
        printParameter
      });
      const blob = new Blob([response], {
        type: "application/pdf",
        encoding: "UTF-8",
      });
      const fileUrl = URL.createObjectURL(blob);
      printPreview.updates({ open: true, url: fileUrl });
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  }

  return (
    <Fragment>
      <Grid container spacing={2} alignItems="center" justifyContent="start">
        <Grid item>
          <Typography fontSize={20}>対象日 :</Typography>
        </Grid>
        <Grid item xs="auto">
          <OutlinedInput
            type="date"
            sx={{ minWidth: 200, fontSize: 20 }}
            inputProps={{
              min: "1000-01-01",
              max: "9999-12-31",
            }}
            onChange={(e) => printSetting.update("targetDate", e.target.value)}
            // onChange={(e)=>console.log(e.target.value)}
            value={printSetting.Value.targetDate}
          />
        </Grid>

        <Grid item>
          <Typography fontSize={20}>帳票タイプ :</Typography>
        </Grid>
        <Grid item>
          <Select
            value={printSetting.Value.reportTypeId}
            onChange={(e) =>
              printSetting.update("reportTypeId", e.target.value)
            }
            sx={{ minWidth: 400, fontSize: 20 }}
          >
            {reportTypes
              .filter((r) => r.displayOrder != 0)
              .map((report, i) => {
                return (
                  <MenuItem key={`reportType${i}`} value={report.reportTypeId}>
                    {report.reportTypeName}
                  </MenuItem>
                );
              })}
          </Select>
        </Grid>
        <Grid item xs="auto">
          <Button variant="contained" fontSize={20} onClick={handlePrint}>
            印刷
          </Button>
        </Grid>
      </Grid>
      <PrintPreview printPreview={printPreview} />
      <PrintParameterDialog
        dialogStatus={printParameterDialogStatus}
        printSetting={printSetting}
      />
    </Fragment>
  );
};
export default PrintBar;
